/**
 * Roadmap Column Component (Enhanced)
 * 
 * Passes upvote, click, and auth handlers to cards
 */
import RoadmapCard from './RoadmapCard';
import { __ } from '@wordpress/i18n';

const RoadmapColumn = ({ status, label, color, highlighted, items, count, loading, onCardClick, onUpvote, isLoggedIn, showVoteCount, onAuthRequired }) => {
    return (
        <div className={`cha-roadmap-column ${highlighted ? 'cha-col-highlighted' : ''}`} data-status={status} style={{ '--col-color': color, background: `color-mix(in srgb, ${color} ${highlighted ? '18' : '10'}%, transparent)`, ...(highlighted ? { borderColor: color } : {}) }}>
            <div className="cha-roadmap-column-header">
                <span 
                    className="cha-roadmap-column-status"
                    style={{ color: color , backgroundColor: `${color}10` ,borderColor: `${color}30` }}
                >
                    {label}
                </span>
                <span className="cha-roadmap-column-count">{count}</span>
            </div>
            
            <div className="cha-roadmap-column-content">
                {loading ? (
                    <div className="cha-roadmap-loading">
                        <div className="cha-spinner"></div>
                    </div>
                ) : items.length === 0 ? (
                    <div className="cha-roadmap-empty">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        <p>{__( 'No items', 'changeloger-pro' )}</p>
                    </div>
                ) : (
                    items.map(item => (
                        <RoadmapCard 
                            key={item.id} 
                            item={item}
                            onCardClick={onCardClick}
                            onUpvote={onUpvote}
                            isLoggedIn={isLoggedIn}
                            showVoteCount={showVoteCount}
                            onAuthRequired={onAuthRequired}
                        />
                    ))
                )}
            </div>
        </div>
    );
};

export default RoadmapColumn;
